export default function assertIsString(val: unknown, name = 'Value'): asserts val is string {
    if (typeof val !== 'string') {
        throw new TypeError(`${name} must be a string`);
    }
}
